import { getApiClient, initializeApiClient } from "../../apiService";

export const UpdateInformationAboutTheTargetGroup = async (
  tG_TargetedGroupId,
  myPNatureOfTargetedGrouproperty,
  tG_TargetedGroupAgeId,
  expectedNumberOfBeneficiaries,
  additionalInformation,
  tG_mainTargetedGroupId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TargetedGroup/UpdateTG_TargetedGroup`,
    {
      tG_TargetedGroupId: tG_TargetedGroupId,
      myPNatureOfTargetedGrouproperty: myPNatureOfTargetedGrouproperty,
      tG_TargetedGroupAgeId: tG_TargetedGroupAgeId,
      expectedNumberOfBeneficiaries: expectedNumberOfBeneficiaries,
      additionalInformation: additionalInformation,
      tG_mainTargetedGroupId: tG_mainTargetedGroupId,
    }
  );

  return response;
};

export default UpdateInformationAboutTheTargetGroup;
